"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingComponent = {
    functional: true,
    props: {
        rendering: {
            type: Object,
        },
    },
    render: function (createElement, context) {
        var rendering = context.props.rendering;
        var componentName = rendering && rendering.componentName ? rendering.componentName : 'Unnamed Component';
        console.log("Component props for unimplemented '" + componentName + "' component", context.props);
        return createElement('div', {
            style: {
                background: 'darkorange',
                outline: '5px solid orange',
                padding: '10px',
                color: 'white',
                maxWidth: '500px',
            },
        }, [
            createElement('h2', componentName),
            createElement('p', 'JSS component is missing Vue implementation. See the developer console for more information.'),
        ]);
    },
};
